<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="area-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-area">请选择绑定大区</div>
                    <div class="area-view">
                        <div class="area-box" :class="{'list-show' : listShow}">
                        <p class="now" @click="listShow = !listShow"><span>绑定大区：</span>{{ now.name }}<em class="select"></em></p>
                            <div class="area-list" v-if="listShow">
                            <vuescroll>
                                <ul>
                                    <li v-for="area in areas[account_type]"
                                    :key = "area.id"
                                    v-bind:data-aid="area.id"
                                    v-bind:data-name="area.name"
                                    @click="queryPlayer" v-html="area.name"></li>
                                </ul> 
                            </vuescroll>                       
                       </div>
                        </div>
                        <div class="player-info flex-between-center">
                            <div class="player-name text-overflow-1"><p><span>角色昵称：</span>{{ now.playerName }}</p></div>
                        </div>                       
                        
                    </div>
                    <p class="notice"><em class="icon i-warn"></em>注意：绑定大区不可修改</p>
                    <div class="u-btn submit" @click="bindArea"></div>
                    
                </div>
            </div>            
        </div>
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import {
    apiUserBind,
    apiUserQuery,
} from '@/api/index';

export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            submit : false,
            isVip : true,
            toast : false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
                "vip_lv" : -2, 
            },
            areas: {
                pc: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 23,
                    "name": "单刀赴会"
                }],
                wg: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 23,
                    "name": "单刀赴会"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                },{
                    "id": 22,
                    "name": "逍遥津</br>(wegame3)"
                }],
                steam: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                    "id": 23,
                    "name": "单刀赴会"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                },
                ],                
                test: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                }, {
                    "id": 17,
                    "name": "铜雀台</br>(wegame1)"
                }, {
                    "id": 18,
                    "name": "凤仪亭</br>(wegame2)"
                },{
                    "id": 21,
                    "name": "长生殿(Steam)"
                },{
                    "id": 22,
                    "name": "逍遥津</br>(wegame3)"
                },{
                    "id": 23,
                    "name": "单刀赴会"
                }, {
                    "id": 100,
                    "name": "TEST_1"
                }, {
                    "id": 110,
                    "name": "TEST_2"
                }],                
            },
            from : {
                '1' : 'wg',
                '2' : 'steam',
                '0' : 'pc',
            },
            visible : false,
            account_type : 'pc',
            code : '',
            ua : {},
            busy : false,
            no_allowed : false,
            cnt_down : 2,
            cnt_max : 2,                       
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.from[this.$store.state.userinfo.fromType ? this.$store.state.userinfo.fromType.toString() : '0'];
        //this.account_type = process.env.NODE_ENV == 'development' ? 'test' : this.account_type;
        //this.account_type = 'test'
    },           
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');

            apiUserQuery({ areaId : vue.now.id }).then(
                res => {
                    vue.$toast('查询成功');
                    vue.now.playerName = res.data.nickName;
                },
                rej => {
                    vue.$toast(rej.message);
                    vue.now.playerName = '';                        
                },
            ) 

        },
        bindArea(){
            // var _s = e.target;
            var vue = this;

            if(this.busy)return;
            //todo inviteCode
            if(!vue.now.id)return vue.$toast('请先选择绑定大区');
            if(!vue.now.playerName)return vue.$toast('端游未创角');

            this.busy = true;

            apiUserBind({ areaId : vue.now.id }).then(
                res => {
                    vue.$toast('大区绑定成功');

                    vue.$update_evt();               
                
                    this.busy = false;
                    
                    vue.destroyElement();
                },
                rej => {
                    this.busy = false;
                    let msg = rej.code == 1210 ? '您的数据正在更新中，请稍后再试！' : rej.message;
                    vue.destroyElement();
                    //vue.$msg_modal({text : msg , type : 'error'});
                    vue.$toast(msg);
                }
            )  
        },
    },    
}
</script>

<style lang="scss" scoped>
    .area-modal{
        width: 585px;
        background-color: #fcfbfa;
        border: 3px solid #fff;
        font-size: 24px;
        color: #525b65;
        z-index: 1001;
        box-sizing: border-box;
    }

    .dialog-content{
        margin: 4px;
        padding: 10px 0;
        border: 1px solid #f1ede9;
    }

    .t-area{
        width: 127px;
        height: 32px;
        margin: 14px auto 30px;
        background-image: url(~@/assets/images/modal/title-bind.png);
        font-size: 0;
        color: transparent;
        text-align: center;
    }

    .area-view{
        margin-top: 20px;
    }

    .area-view .area-box {
        position: relative;
        width: 540px;
        height: 85px;
        line-height: 85px;
        margin: 0 auto 0;
        box-sizing: border-box;
        color: #ce4f3c;        
        border: 2px solid #f1ede9;
        vertical-align: middle;
        z-index: 10;
    }

    .area-view .area-box.list-show{
        /* background-color: #f9eecf; */
    }

    .area-box p {
        position: relative;
        padding-left: 36px;
        line-height: 85px;
    }

    .area-box .now .select {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 37px;
        width: 24px;
        height: 16px;
        transform: translateY(-50%);
    }

    .area-box .now .select::after{
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/modal/icon-select.png);
        background-size: 24px 16px;
        background-position: center;
        background-repeat: no-repeat;
    }  

    .area-box .now span {
        padding-right: 42px;
        color: #ce4f3c; 
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 76px;
        left: 50%;
        width: 540px;
        height: 250px;
        padding: 20px 15px 0 15px;
        background-color: #fffef8;
        color: #ce4f3c;  
        z-index: 50;
        box-sizing: border-box;
        transform: translateX(-50%);
        border: 2px solid #f1ede9;
        border-top: none;
    }

    .area-view .area-list ul{
        display: flex;
        /* justify-content: space-between; */
        flex-wrap: wrap;
    }

    .area-view .area-list li {
        /* display: inline-block; */
        width: 50%;
        line-height: 40px;
        margin-bottom: 12px;
        text-align: center;
        box-sizing: content-box;
        /* border-bottom: 1px dashed #e3e3e3; */
    }

    .player-info{
        width: 540px;
        margin: 20px auto 0;
    }

    .area-view .player-name {
        position: relative;
        width: 540px;
        height: 85px;
        line-height: 85px;
        // margin: 0 auto 20px;
        box-sizing: border-box;
        color: #ce4f3c;
        vertical-align: middle;
        border: 2px solid #f1ede9;
        font-size: 24px;
    }

    .area-view .player-name p{
        
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 30px;
        padding-right: 20px;
        color: #ce4f3c;      
    }





    .area-modal .u-btn.submit{
        width: 286px;
        height: 79px;
        margin: 5px auto 0;
        background-image: url(~@/assets/images/modal/btn-ok.png);    
    }
    
    .warn{
        margin-top: 34px;
        margin-bottom: 26px;
        color: #ffdf7e;
        font-size: 20px;
    }

    .notice{
        margin: 12px 0;
        font-size: 20px;
        color: #d45c3d;
        text-align: center;
    }

    .i-warn{
        display: inline-block;
        width: 17px;
        height: 18px;
        margin-right: 10px;
        background-image: url(~@/assets/images/modal/icon-warn.png);
        vertical-align: middle;
    }    

    .u-btn.close {
        position: absolute;
        top: 20px;
        right: 22px;
        width: 22px;
        height: 22px;
        background-image: url(~@/assets/images/modal/btn-close.png);
        z-index: 1002;
    }
</style>


<style>
.van-loading{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 3000;
}
</style>